import { render } from "./VideoPlaylist.vue?vue&type=template&id=4bbd50c2&scoped=true"
import script from "./VideoPlaylist.vue?vue&type=script&lang=js"
export * from "./VideoPlaylist.vue?vue&type=script&lang=js"

import "./VideoPlaylist.vue?vue&type=style&index=0&id=4bbd50c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bbd50c2"]])

export default __exports__